(function () {
  function icon(d) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', d);
    s.appendChild(p);
    return s;
  }
  function button(cls, label, child) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('aria-label', label);
    if (child) b.appendChild(child);
    return b;
  }
  function build(track) {
    if (track.getAttribute('data-vl-ready')) return;
    track.setAttribute('data-vl-ready', '1');
    var overlay = track.hasAttribute('data-vl-overlay');
    var ctrl = document.createElement('div');
    ctrl.className = 'vl-ctrl';
    var prev = button('vl-arrow', 'Previous', icon('M15 6l-6 6 6 6'));
    var next = button('vl-arrow', 'Next', icon('M9 6l6 6-6 6'));
    var dots = document.createElement('div');
    dots.className = 'vl-dots';
    if (overlay) {
      prev.className += ' vl-arrow--ov vl-arrow--l';
      next.className += ' vl-arrow--ov vl-arrow--r';
      var stage = track.parentNode;
      stage.appendChild(prev);
      stage.appendChild(next);
      ctrl.appendChild(dots);
      stage.parentNode.insertBefore(ctrl, stage.nextSibling);
    } else {
      ctrl.appendChild(prev);
      ctrl.appendChild(dots);
      ctrl.appendChild(next);
      track.parentNode.insertBefore(ctrl, track.nextSibling);
    }
    var pages = 1;
    var stride = 1;
    function items() {
      return Array.prototype.filter.call(track.children, function (c) { return c.offsetWidth > 0; });
    }
    function showControls(on) {
      ctrl.style.display = on ? '' : 'none';
      if (overlay) {
        prev.style.display = on ? '' : 'none';
        next.style.display = on ? '' : 'none';
      }
    }
    function update() {
      var i = Math.min(pages - 1, Math.max(0, Math.round(track.scrollLeft / stride)));
      var ds = dots.children;
      for (var k = 0; k < ds.length; k++) ds[k].setAttribute('aria-current', k === i ? 'true' : 'false');
      prev.disabled = i === 0;
      next.disabled = i >= pages - 1;
    }
    function measure() {
      var it = items();
      if (!it.length) { showControls(false); return; }
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap) || 0;
      var w = it[0].offsetWidth;
      var per = Math.max(1, Math.round((track.clientWidth + gap) / (w + gap)));
      stride = per * (w + gap);
      var n = Math.ceil(it.length / per);
      if (n !== pages || dots.children.length !== n) {
        pages = n;
        dots.innerHTML = '';
        for (var k = 0; k < n; k++) {
          (function (idx) {
            var d = button('vl-dot', 'Go to slide ' + (idx + 1), null);
            d.addEventListener('click', function () { track.scrollTo({ left: idx * stride, behavior: 'smooth' }); });
            dots.appendChild(d);
          })(k);
        }
      }
      showControls(pages > 1);
      update();
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -stride, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: stride, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);
    measure();
  }
  function autoplay() {
    var vids = document.querySelectorAll('[data-vl-slider] video[autoplay]');
    if (!vids.length) return;
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.4 });
    }
    vids.forEach(function (v) {
      if (v.getAttribute('data-vl-io')) return;
      v.setAttribute('data-vl-io', '1');
      v.muted = true;
      if (io) io.observe(v);
    });
  }
  function init() {
    document.querySelectorAll('[data-vl-slider]').forEach(build);
    autoplay();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
